import axios from '../request';
/**
 * 项目管理模块接口
*/
export default {
/**
 * 项目信息管理模块
*/
// 查询项目信息管理列表
searchProjectInfoList: (params) =>
  axios({
    method: 'post',
    url: '/pm/projectInfo/findList',
    headers: {
      pageNum: params.pageNum,
      pageSize: params.pageSize
    },
    data: {
      proId: params.proId,
      proNo: params.proNo,
      segmentId: params.segmentId
    }
  }),
// 添加 修改 项目信息管理
insertProjectInfo: (params) =>
  axios.post('/pm/projectInfo/addProjectInfo', params),
// 查询项目下文件列表信息
getProjectFileInfo: (params) =>
  axios.post('/pm/projectInfo/fileList', params),


/**
 * 图纸管理模块
*/
// 查询图纸信息列表
searchDrawingTypeList: (params) =>
  axios({
    method: 'post',
    url: '/pm/drawType/findList',
    headers: {
      pageNum: params.pageNum,
      pageSize: params.pageSize
    },
  }),
  // 添加 修改 图纸类型信息
  insertDrawingTypeInfo: (params) =>
    axios.post('/pm/drawType/addDrawType', params),
  // 删除图纸类型信息
  deleteDrawingTypeInfo: (params) =>
    axios.post('/pm/drawType/delete', params),
  // 查询图纸列表
  searchDrawingInfoList: (params) =>
    axios({
      method: 'post',
      url: '/pm/draw/findList',
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      },
      data: {
        drawTypeId: params.drawTypeId
      }
    }),
  // 添加 修改 图纸信息
  insertDrawingInfo: (params) =>
    axios.post('/pm/draw/addDraw', params),
  // 删除图纸信息
  deleteDrawingInfo: (params) =>
    axios.post('/pm/draw/delete', params),
  // 查询图纸文件列表
  searchDrawingFileList: (params) =>
    axios({
      method: 'post',
      url: '/pm/draw/fileList',
      headers: {
        pageNum: 1,
        pageSize: 1000000
      },
      data: params
    }),
  
  /**
   * 合同管理模块
  */
  // 查询合同信息列表
  searchContractInfoList: (params) =>
    axios({
      method: 'post',
      url: '/pm/contract/findList',
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      },
      data: {
        contractNum: params.contractNum,
        contractName: params.contractName
      }
    }),
  // 添加 修改 合同信息
  insertContractInfo: (params) =>
    axios.post('/pm/contract/addContract', params),
  // 删除合同信息
  deleteContractInfo: (params) =>
    axios.post('/pm/contract/delete', params),
  // 获取合同文件信息
  searchContractFileList: (params) =>
    axios({
      method: 'post',
      url: '/pm/contract/fileList',
      headers: {
        pageNum: 1,
        pageSize: 1000000
      },
      data: params
    }),
  
  
  /**
   * 技术文件管理模块
  */
  // 查询技术文件类型信息列表
  searchTechnicalTypeList: (params) =>
    axios({
      method: 'post',
      url: '/pm/tchFileType/findList',
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      }
    }),
  // 添加 修改 技术文件类型信息
  insertTechnicalTypeInfo: (params) =>
    axios.post('/pm/tchFileType/addTchFileType', params),
  // 删除技术文件类型信息
  deleteTechnicalTypeInfo: (params) =>
    axios.post('/pm/tchFileType/delete', params),

  // 查询技术文件信息列表
  searchTechnicalDocmentList: (params) =>
    axios({
      method: 'post',
      url: '/pm/tchFile/findList',
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      },
      data: {
        tchFileTypeId: params.tchFileTypeId
      }
    }),
  // 添加 修改 技术文件信息
  insertTechnicalDocmentInfo: (params) =>
    axios.post('/pm/tchFile/addTchFile', params),
  // 删除技术文件信息
  deleteTechnicalDocmentInfo: (params) =>
    axios.post('/pm/tchFile/delete', params),
  // 获取技术问文件文件信息
  searchTechnicalDocmentFileList: (params) =>
    axios({
      method: 'post',
      url: '/pm/tchFile/fileList',
      headers: {
        pageNum: 1,
        pageSize: 1000000
      },
      data: params
    }),
  


  /**
   * 会议管理模块
  */
  // 查询会议信息列表
  searchMeetingInfoList: (params) => 
    axios({
      method: 'post',
      url: '/pm/meet/findList',
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      },
      data: {
        meetTopic: params.meetTopic,
        startTime: params.startTime,
        endTime: params.endTime
      }
    }),
  // 添加 修改会议信息
  insertMeetingInfo: (params) =>
    axios.post('/pm/meet/addMeet', params),
  // 删除会议信息
  deleteMeetingInfo: (params) =>
    axios.post('/pm/meet/delete', params),
  // 获取会议文件信息
  searchMeetingFileList: (params) =>
    axios({
      method: 'post',
      url: '/pm/meet/fileList',
      headers: {
        pageNum: 1,
        pageSize: 1000000
      },
      data: params
    }),
}